module.exports = __webpack_public_path__ + "assets/6f9a9c5e8a07ad6889f42e17b74d9ce4.mp3";